import { externalLinkProps } from "../../utils/directoryUtils";

export default function OfficialLinkButton({ href, children, variant = "secondary", ariaLabel }) {
  if (!href) return null;
  return (
    <a
      href={href}
      {...externalLinkProps()}
      aria-label={ariaLabel || children}
      className={variant === "primary" ? "btn-primary" : "btn-secondary"}
    >
      {children}
      <span aria-hidden="true" className="ml-2">↗</span>
    </a>
  );
}
